import { AppModule } from '@/store/modules/app'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import i18n from '@/lang'

const timezoneList = new Proxy({} as Record<string, number>, {
  get(target, tzName: string) {
    try {
      // 使用 moment-timezone 获取时区偏移（分钟），转换为小时
      const offsetMinutes = momentTimezone.tz(tzName).utcOffset()
      return -(offsetMinutes / 60) // 注意：utcOffset() 返回值的符号与常规相反
    } catch (e) {
      return 0
    }
  }
})

export const pickerOptions = {
  shortcuts: [
    {
      text: i18n.t('time.halfhHour'),
      onClick(picker) {
        let zoneTime: any = localStorage.getItem('zoneTime')
        const end = new Date(zoneTime)
        const start = new Date(zoneTime)
        start.setTime(start.getTime() - 3600 * 500)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('time.oneHour'),
      onClick(picker) {
        let zoneTime: any = localStorage.getItem('zoneTime')
        const end = new Date(zoneTime)
        const start = new Date(zoneTime)
        start.setTime(start.getTime() - 3600 * 1000)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('time.fourHour'),
      onClick(picker) {
        let zoneTime: any = localStorage.getItem('zoneTime')
        const end = new Date(zoneTime)
        const start = new Date(zoneTime)
        start.setTime(start.getTime() - 3600 * 4000)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('time.yesterday'),
      onClick(picker) {
        const time_tuple = getOneTimeZome()
        const end: any = time_tuple[1]
        const start: any = time_tuple[0]
        start.setTime(start)
        end.setTime(end)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('time.lastMonth'),
      onClick(picker) {
        const date = new Date()
        // 上个月天数
        const time = new Date(date.getFullYear(), date.getMonth(), 0).getDate()
        // 上个月1号
        const start = new Date(date.getFullYear(), date.getMonth() - 1, 1)
        // 当月1号
        const end = new Date(date.getFullYear(), date.getMonth() - 1, time + 1)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('time.aWeek'),
      onClick(picker: any) {
        const time_tuple = getOneWeekDate()
        const end: any = time_tuple[1]
        const start: any = time_tuple[0]
        start.setTime(start)
        end.setTime(end)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('time.aMonth'),
      onClick(picker: any) {
        const time_tuple = getOneMonthDate()
        const end: any = time_tuple[1]
        const start: any = time_tuple[0]
        start.setTime(start)
        end.setTime(end)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: i18n.t('time.threeMonths'),
      onClick(picker: any) {
        const time_tuple = getThreeMonthDate()
        const end: any = time_tuple[1]
        const start: any = time_tuple[0]
        start.setTime(start)
        end.setTime(end)
        picker.$emit('pick', [start, end])
      }
    }
  ]
}

export const pickerAddOptions = {
  shortcuts: [
    {
      text: i18n.t('time.five'),
      onClick(picker) {
        let zoneTime: any = localStorage.getItem('zoneTime')
        const start = new Date(zoneTime)
        start.setTime(start.getTime() - 5 * 60 * 1000)
        picker.$emit('pick', start)
      }
    },
    {
      text: i18n.t('time.ten'),
      onClick(picker) {
        let zoneTime: any = localStorage.getItem('zoneTime')
        const start = new Date(zoneTime)
        start.setTime(start.getTime() - 10 * 60 * 1000)
        picker.$emit('pick', start)
      }
    },
    {
      text: i18n.t('time.halfhHour'),
      onClick(picker) {
        let zoneTime: any = localStorage.getItem('zoneTime')
        const start = new Date(zoneTime)
        start.setTime(start.getTime() - 3600 * 500)
        picker.$emit('pick', start)
      }
    },
    {
      text: i18n.t('time.oneHour'),
      onClick(picker) {
        let zoneTime: any = localStorage.getItem('zoneTime')
        const start = new Date(zoneTime)
        start.setTime(start.getTime() - 3600 * 1000)
        picker.$emit('pick', start)
      }
    }
  ]
}

// 时间段拼接 10:00-12:00
export const timeJoin = (o1: any, o2: any) => {
  return moment(o1).format('HH:mm') + '-' + moment(o2).format('HH:mm')
}

// 将时间段字符串转化为两个时间 10:00-12:00
export const strToDateArray = (str: string) => {
  const dateArr: any[] = []
  const subStrs = str.split('-')
  subStrs.forEach((sub: any) => {
    const subs = sub.split(':')
    dateArr.push(new Date(2020, 10, 10, subs[0] * 1, subs[1] * 1))
  })
  return dateArr
}

// 将时间转化为系统平台时区的时间戳 秒数
export const dateToSeconds = (obj: any) => {
  if (!obj) {
    return null
  }
  // 获取当前浏览器（运行环境）的时区
  const currentTimezone: number = obj.getTimezoneOffset() / 60
  // 系统平台时区
  const timezone: number =
    timezoneList[
    AppModule.constant['CURRENCY_TIMEZONE_MAP'][AppModule.currentCurrencyType]
    ] || currentTimezone

  return (
    parseFloat(
      moment(dateToTimezone(obj), 'YYYY-MM-DD HH:mm:ss Z').format('X')
    ) +
    (timezone - currentTimezone) * 60 * 60
  )
}

// 将时间转化为系统平台时区的时间戳 秒数（去除时区偏移量）
export const dateNotTimezone = (obj: any) => {
  if (!obj) {
    return null
  }
  // 获取当前浏览器（运行环境）的时区
  const currentTimezone: number = obj.getTimezoneOffset() / 60
  // 系统平台时区
  const timezone: number = currentTimezone
  return (
    parseFloat(
      moment(dateToTimezone(obj), 'YYYY-MM-DD HH:mm:ss Z').format('X')
    ) +
    (timezone - currentTimezone) * 60 * 60
  )
}

// 将时间转化为系统平台时区时间
export const dateToSecondsCurrery = (obj: any) => {
  if (!obj) {
    return null
  }
  return parseFloat(
    moment(dateToTimezone(obj), 'YYYY-MM-DD HH:mm:ss Z').format('X')
  )
}

// 将时间转化为系统平台时区时间
export const dateToTimezone = (obj: any) => {
  return momentTimezone
    .tz(
      obj,
      AppModule.constant['CURRENCY_TIMEZONE_MAP'][AppModule.currentCurrencyType]
    )
    .format('YYYY-MM-DD HH:mm:ss Z')
}

// 将时间转化为系统平台时区日期
export const dateToDatezone = (obj: any) => {
  return momentTimezone
    .tz(
      obj,
      AppModule.constant['CURRENCY_TIMEZONE_MAP'][AppModule.currentCurrencyType]
    )
    .format('YYYY-MM-DD')
}

// 将时间转化为系统平台时区-时分
export const dateToDatezoneHM = (obj: any) => {
  return momentTimezone
    .tz(
      obj,
      AppModule.constant['CURRENCY_TIMEZONE_MAP'][AppModule.currentCurrencyType]
    )
    .format('HH:mm')
}

// 将时间转化为系统平台时区日期-时分
export const dateToDatezoneDHM = (obj: any) => {
  return momentTimezone
    .tz(
      obj,
      AppModule.constant['CURRENCY_TIMEZONE_MAP'][AppModule.currentCurrencyType]
    )
    .format('MM-DD HH:mm')
}

// 获取当前最近三个月日期
export const getThreeMonthDate = () => {
  const date = new Date() // 当前时间
  const date1 = moment(date).format('YYYY-MM-DD') // 当前日期
  const date2 = moment(date).subtract(90, 'days').format('YYYY-MM-DD') // 前90天日期
  const d1: any[] = date1.split('-')
  const d2: any[] = date2.split('-')
  return [new Date(d2[0], d2[1] - 1, d2[2]), new Date(d1[0], d1[1] - 1, d1[2])]
}

// 获取当前最近一个月日期
export const getOneMonthDate = () => {
  const date = new Date() // 当前时间
  const date1 = moment(date).format('YYYY-MM-DD') // 当前日期
  const date2 = moment(date).subtract(30, 'days').format('YYYY-MM-DD') // 前30天日期
  const d1: any[] = date1.split('-')
  const d2: any[] = date2.split('-')
  return [new Date(d2[0], d2[1] - 1, d2[2]), new Date(d1[0], d1[1] - 1, d1[2])]
}

// 获取当前最近一周日期
export const getOneWeekDate = () => {
  const date = new Date() // 当前时间
  const date1 = moment(date).format('YYYY-MM-DD') // 当前日期
  const date2 = moment(date).subtract(7, 'days').format('YYYY-MM-DD') // 前7天日期
  const d1: any[] = date1.split('-')
  const d2: any[] = date2.split('-')
  return [new Date(d2[0], d2[1] - 1, d2[2]), new Date(d1[0], d1[1] - 1, d1[2])]
}

// 获取当前最近一天日期
export const getOneDate = () => {
  const date = new Date() // 当前时间
  const date1 = moment(date).format('YYYY-MM-DD') // 当前日期
  const date2 = moment(date).subtract(1, 'days').format('YYYY-MM-DD') // 昨天日期
  const d1: any[] = date1.split('-')
  const d2: any[] = date2.split('-')
  return [new Date(d2[0], d2[1] - 1, d2[2]), new Date(d1[0], d1[1] - 1, d1[2])]
}

// 获取时区日期前一天日期
export const getOneTimeZome = () => {
  const date = momentTimezone.tz(
    new Date(),
    AppModule.constant['CURRENCY_TIMEZONE_MAP'][AppModule.currentCurrencyType]
  ) // 当前时间
  const date1 = moment(date).format('YYYY-MM-DD') // 当前日期
  const date2 = moment(date).subtract(1, 'days').format('YYYY-MM-DD') // 昨天日期
  const d1: any[] = date1.split('-')
  const d2: any[] = date2.split('-')
  return [new Date(d2[0], d2[1] - 1, d2[2]), new Date(d1[0], d1[1] - 1, d1[2])]
}

// 获取货币当前日期
export const getCurrentDate = () => {
  const date = momentTimezone.tz(
    new Date(),
    AppModule.constant['CURRENCY_TIMEZONE_MAP'][AppModule.currentCurrencyType]
  ) // 当前时间
  const date1 = moment(date).format('YYYY-MM-DD') // 当前日期
  const date2 = moment(date).add(1, 'days').format('YYYY-MM-DD') // 明天日期
  const d1: any[] = date1.split('-')
  const d2: any[] = date2.split('-')
  return [new Date(d1[0], d1[1] - 1, d1[2]), new Date(d2[0], d2[1] - 1, d2[2])]
}

// 获取系统当前日期
export const getSystemDate = () => {
  const date = new Date() // 当前时间
  const date1 = moment(date).format('YYYY-MM-DD') // 当前日期
  const date2 = moment(date).add(1, 'days').format('YYYY-MM-DD') // 明天日期
  const d1: any[] = date1.split('-')
  const d2: any[] = date2.split('-')
  return [new Date(d1[0], d1[1] - 1, d1[2]), new Date(d2[0], d2[1] - 1, d2[2])]
}

/**
 * 工具： 时间格式过滤器
 * @des {描述} 兼容IE等浏览器的时间过滤
 * @param {时间参数:date} date
 * @param {类型参数:string} type : 默认只有年月日, h -> 时, hm -> 时分, hms -> 时分秒
 * @res {返回值} YYYY-MM-DD
 */

export const formatDate = (date, type) => {
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let min = date.getMinutes()
  let sec = date.getSeconds()

  if (month < 10) month = '0' + month
  if (day < 10) day = '0' + day
  let base = year + '-' + month + '-' + day
  if (type === 'h') return base + ' ' + hours
  if (type === 'hm') return base + ' ' + hours + ':' + min
  if (type === 'hms') return base + ' ' + hours + ':' + min + ':' + sec
  return base
}
